import { AlertDialog } from "client/Components";
import { navigateToWorkspace } from "client/Features/Workspace/routing";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export const ExchangeAuthenticationErrorDialog = (): ReactElement => (
	<AlertDialog
		title={localize("_AuthenticationError")}
		confirmText={localize("_BackToWorkspace")}
		onClose={() => navigateToWorkspace()}
		trackingId="exchange-authentication-error-dialog"
	>
		{localize("_ExchangeAuthenticationErrorText")}
	</AlertDialog>
);

ExchangeAuthenticationErrorDialog.displayName = "ExchangeAuthenticationErrorDialog";